import { render, staticRenderFns } from "./settlement-dialog.vue?vue&type=template&id=6a744ed3&scoped=true"
import script from "./settlement-dialog.vue?vue&type=script&lang=js"
export * from "./settlement-dialog.vue?vue&type=script&lang=js"
import style0 from "./settlement-dialog.vue?vue&type=style&index=0&id=6a744ed3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a744ed3",
  null
  
)

export default component.exports